import { render, staticRenderFns } from "./next-query-results.vue?vue&type=template&id=057e8d4d&"
import script from "./next-query-results.vue?vue&type=script&lang=ts&"
export * from "./next-query-results.vue?vue&type=script&lang=ts&"
import style0 from "./next-query-results.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports